export default {
  FETCH_EARNINGS_HISTORY_REQUEST: 'FETCH_EARNINGS_HISTORY_REQUEST',
  FETCH_EARNINGS_HISTORY_SUCCESS: 'FETCH_EARNINGS_HISTORY_SUCCESS',
  FETCH_EARNINGS_HISTORY_FAILURE: 'FETCH_EARNINGS_HISTORY_FAILURE',

  DOWNLOAD_EARNINGS_HISTORY_REPORT_REQUEST: 'DOWNLOAD_EARNINGS_HISTORY_REPORT_REQUEST',
  DOWNLOAD_EARNINGS_HISTORY_REPORT_SUCCESS: 'DOWNLOAD_EARNINGS_HISTORY_REPORT_SUCCESS',
  DOWNLOAD_EARNINGS_HISTORY_REPORT_FAILURE: 'DOWNLOAD_EARNINGS_HISTORY_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/earnings-history/action-types.js